import { getInitData } from './telegram'

const API_BASE = import.meta.env.VITE_API_URL ?? ''

export async function apiFetch<T>(path: string): Promise<T> {
  const initData = getInitData()
  const res = await fetch(`${API_BASE}/api${path}`, {
    headers: {
      'X-Telegram-Init-Data': initData,
    },
  })
  if (!res.ok) throw new Error(`API error: ${res.status}`)
  return res.json() as Promise<T>
}
